import RedirectIfAuthenticatedRoute from './RedirectIfAuthenticatedRoute'
export default RedirectIfAuthenticatedRoute